import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
//Layouts
import AuthLayout from './components/layouts/AuthLayout';
import Layout from './components/layouts/Layout';
//Views
import Registro from './views/Registro/Registro';
import Login from './views/Login/Login';
import ResetPassword from './views/ResetPassword';
import DocenteHome from './views/DocenteHome/DocenteHome';
import EstudianteHome from './views/EstudianteHome/EstudianteHome';
import Unauthorized from './views/Unauthorized';
import Ova from './views/Ova';
import Profile from './views/Profile/Profile';
import Progeso from './views/Progreso/Progeso';
import NotFound from './views/NotFound';
//Hooks
import SessionTimeout from './hooks/SessionTimeout';
import RequireAuth from './routes/RequireAuth';
//Context
import { AuthProvider } from './context/AuthProvider';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/*Rutas públicas*/}
          <Route path="unauthorized" element={<Unauthorized />} />
          
          {/*Rutas de autenticación*/}
          <Route path='/' element={<AuthLayout />}>
            <Route index element={<Login />}></Route>
            <Route path='/registro' element={<Registro />}></Route>
            <Route path='/resetPassword/:_id' element={<ResetPassword />}></Route>
          </Route>

          {/*Rutas privadas*/}

          {/*Global private routing here*/}
          <Route element={<RequireAuth allowedRoles={["estudiante","docente"]}/>}>
            <Route path='/' element={<Layout />}>
              <Route Route path='/profile' element={<Profile/>}></Route>
            </Route>
          </Route>

          {/*Rutas privadas estudiante*/}
          <Route element={<RequireAuth allowedRoles={["estudiante"]} />}>
            <Route path='/' element={<Layout />}>
              <Route Route path='/ova/:_id' element={<Ova/>}></Route>
              <Route Route path='/home' element={<EstudianteHome />}></Route>
            </Route>
          </Route>

          {/*Rutas privadas docente*/}
          <Route element={<RequireAuth allowedRoles={["docente"]} />}>
            <Route path='/' element={<Layout />}>
              <Route Route path='/homeDocente' element={<DocenteHome />}></Route>
              <Route Route path='/progreso/:codigo/:nombreCurso' element={<Progeso />}></Route>
            </Route>
          </Route>
        
          {/*Errores*/}
          <Route path='*' element={<NotFound/>}/>
        </Routes>
        <SessionTimeout />
      </AuthProvider>
    </BrowserRouter>
  )
}
